/**
 * backend-url.js — single source of truth for resolving the API base URL.
 *
 * The frontend is bundled once with REACT_APP_BACKEND_URL baked in (the
 * Emergent platform's preview/canonical hostname). When the same bundle is
 * served from a linked custom domain (lesconcierge.com · kvb.mindescapes.in),
 * we must NOT call the canonical hostname for API requests — because the
 * backend resolves tenant from the Host header. Calling the canonical host
 * would land every request on the `global` tenant, breaking the gate.
 *
 * Resolution:
 *   - SSR / no window → return the build-time URL (best-effort).
 *   - Build URL empty → return "" (relative URLs).
 *   - Same origin as build URL → use build URL as-is (preview path).
 *   - Different origin (linked custom domain) → use the current window origin
 *     so the backend Host header carries the user-facing hostname.
 *
 * FIR-20260611-001 · custom-domain tenant routing fix
 */

const _BUILD_URL = process.env.REACT_APP_BACKEND_URL || "";

export function resolveBackendUrl() {
  if (typeof window === "undefined") return _BUILD_URL;
  if (!_BUILD_URL) return "";
  try {
    const buildOrigin = new URL(_BUILD_URL).origin;
    return window.location.origin === buildOrigin ? _BUILD_URL : window.location.origin;
  } catch {
    return _BUILD_URL;
  }
}

export const BACKEND_URL = resolveBackendUrl();
